import { UserCreationFormState } from '../CreateUserContext/types';
import { snakify } from 'helpers/syntaxHelper';

/**
 * Middleware meant to be used as a PreProcessingBodyCallback into APIClient.
 * Camelize blockName within user.scopes.
 * The reason why some blockNames are, sometimes, camelized, is not clearly known.
 */
export const userPreProcessingBodyCallback = (body: UserCreationFormState) => {
    if (body.scopes === undefined) {
        return body;
    }

    const formattedScopes = body.scopes.map((scope) => {
        return {
            ...scope,
            blocks: scope.blocks.map((block) => {
                return { ...block, name: snakify(block.name) };
            }),
        };
    });
    return { ...body, scopes: formattedScopes };
};
